/** Turn `API 502: {"error":"..."}` into a short human message. */
export function formatApiError(err: unknown): string {
  if (!(err instanceof Error)) return "Something went wrong";
  const match = err.message.match(/^API (\d+):\s*(.+)$/s);
  if (!match) return err.message;
  const [, status, body] = match;
  try {
    const parsed = JSON.parse(body) as { error?: string; detail?: string };
    const msg = parsed.error ?? parsed.detail ?? body;
    return status === "409"
      ? "This file was updated elsewhere. Reload and try again."
      : msg;
  } catch {
    return body.length > 120 ? `${body.slice(0, 120)}…` : body;
  }
}
